(function () {
  'use strict';

  /* ── Config ── */
  var MAX_W = 360; // px max canvas display width
  var MAX_H = 480; // px max canvas display height
  var PAD   = 2;   // mm inner padding

  /* ── State ── */
  var state = {
    format: { w: 58, h: 60, label: '58\xD760 mm' },
    logo: null,
    logoSizePct: 45,
    logoPos: 'tc',
    texts: { produit: '', prix: '', lot: '', date: '' },
  };

  /* ── DOM ── */
  var canvas   = document.getElementById('cfg-canvas');
  var ctx      = canvas.getContext('2d');

  /* ── Scale ── */
  function getScale(w, h) {
    return Math.min(MAX_W / w, MAX_H / h);
  }

  /* ── Logo position (in mm from label top-left) ── */
  function getLogoXY(pos, lw, lh, fw, fh, textZoneH) {
    var safeH = fh - textZoneH - PAD;
    var positions = {
      tl: { x: PAD,            y: PAD },
      tc: { x: (fw - lw) / 2,  y: PAD },
      tr: { x: fw - lw - PAD,  y: PAD },
      ml: { x: PAD,            y: (safeH - lh) / 2 },
      mc: { x: (fw - lw) / 2,  y: (safeH - lh) / 2 },
      mr: { x: fw - lw - PAD,  y: (safeH - lh) / 2 },
      bl: { x: PAD,            y: Math.max(PAD, safeH - lh) },
      bc: { x: (fw - lw) / 2,  y: Math.max(PAD, safeH - lh) },
      br: { x: fw - lw - PAD,  y: Math.max(PAD, safeH - lh) },
    };
    var p = positions[pos] || positions.tc;
    // clamp inside label
    p.x = Math.max(0, Math.min(p.x, fw - lw));
    p.y = Math.max(0, Math.min(p.y, fh - lh));
    return p;
  }

  /* ── Text zone height (mm) ── */
  function textZoneH(texts) {
    var lines = 0;
    if (texts.produit) lines += 1.4;
    if (texts.prix)    lines += 1.2;
    if (texts.lot || texts.date) lines += 1.1;
    return lines > 0 ? lines * 2.6 + 4 : 0; // 4mm = barcode + padding
  }

  /* ── Rounded rect helper ── */
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  /* ── Main draw ── */
  function draw() {
    var fw   = state.format.w;
    var fh   = state.format.h;
    var sc   = getScale(fw, fh);
    var cW   = Math.round(fw * sc);
    var cH   = Math.round(fh * sc);

    canvas.width  = cW;
    canvas.height = cH;

    /* background */
    roundRect(ctx, 0, 0, cW, cH, 4);
    ctx.fillStyle = '#ffffff';
    ctx.fill();
    ctx.strokeStyle = '#c8d5e0';
    ctx.lineWidth = 1;
    ctx.stroke();

    /* subtle shadow strip on left (thermal label look) */
    ctx.fillStyle = 'rgba(0,0,0,0.03)';
    ctx.fillRect(0, 0, 6, cH);

    var tzH  = textZoneH(state.texts);  // mm
    var tzHpx = tzH * sc;

    /* ── Logo ── */
    if (state.logo) {
      var lw_mm = fw * state.logoSizePct / 100;
      var lh_mm = (state.logo.naturalHeight / state.logo.naturalWidth) * lw_mm;
      // cap height so logo doesn't exceed available zone
      var maxLH = fh - tzH - PAD * 2;
      if (lh_mm > maxLH && maxLH > 0) {
        lh_mm = maxLH;
        lw_mm = (state.logo.naturalWidth / state.logo.naturalHeight) * lh_mm;
      }
      var pos = getLogoXY(state.logoPos, lw_mm, lh_mm, fw, fh, tzH);
      ctx.drawImage(state.logo, pos.x * sc, pos.y * sc, lw_mm * sc, lh_mm * sc);
    }

    /* ── Text zone ── */
    if (tzH > 0) {
      var texts = state.texts;
      var tzY   = cH - tzHpx;

      /* separator */
      ctx.strokeStyle = '#e2e8f0';
      ctx.lineWidth = 0.8;
      ctx.beginPath();
      ctx.moveTo(4 * sc, tzY + 1 * sc);
      ctx.lineTo(cW - 4 * sc, tzY + 1 * sc);
      ctx.stroke();

      var ty = tzY + 1.8 * sc;
      ctx.textBaseline = 'top';

      if (texts.produit) {
        ctx.font = 'bold ' + Math.round(2.0 * sc) + 'px Arial, sans-serif';
        ctx.fillStyle = '#0f172a';
        ctx.textAlign = 'center';
        ctx.fillText(clip(texts.produit, 28), cW / 2, ty);
        ty += 2.4 * sc;
      }

      if (texts.prix) {
        ctx.font = Math.round(1.65 * sc) + 'px Arial, sans-serif';
        ctx.fillStyle = '#334155';
        ctx.textAlign = 'center';
        ctx.fillText(clip(texts.prix, 22), cW / 2, ty);
        ty += 2.0 * sc;
      }

      if (texts.lot || texts.date) {
        ctx.font = Math.round(1.35 * sc) + 'px Arial, sans-serif';
        ctx.fillStyle = '#64748b';
        if (texts.lot && texts.date) {
          ctx.textAlign = 'left';
          ctx.fillText('Lot: ' + texts.lot, PAD * sc, ty);
          ctx.textAlign = 'right';
          ctx.fillText(texts.date, cW - PAD * sc, ty);
        } else {
          ctx.textAlign = 'center';
          ctx.fillText(texts.lot ? 'Lot: ' + texts.lot : texts.date, cW / 2, ty);
        }
        ty += 1.8 * sc;
      }

      /* barcode placeholder */
      var bcW  = fw * 0.58 * sc;
      var bcH  = 1.4 * sc;
      var bcX  = (cW - bcW) / 2;
      var bcY  = cH - 2.2 * sc;
      ctx.fillStyle = '#1e293b';
      var bars = 22;
      var bw   = bcW / (bars * 1.65);
      for (var i = 0; i < bars; i++) {
        var bx = bcX + i * bw * 1.65;
        var bh = (i % 4 === 0) ? bcH * 1.25 : bcH;
        ctx.fillRect(bx, bcY - bh + bcH, bw, bh);
      }
    }
  }

  function clip(str, max) {
    return str.length > max ? str.slice(0, max - 1) + '…' : str;
  }

  /* ── Format buttons ── */
  document.querySelectorAll('.cfg-fmt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.cfg-fmt').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      state.format = {
        w: parseFloat(this.dataset.w),
        h: parseFloat(this.dataset.h),
        label: this.textContent.trim(),
      };
      draw();
    });
  });

  /* ── Logo upload ── */
  var dzEmpty   = document.getElementById('cfg-dz-empty');
  var dzFilled  = document.getElementById('cfg-dz-filled');
  var logoThumb = document.getElementById('cfg-logo-thumb');
  var logoName  = document.getElementById('cfg-logo-name');
  var logoOpts  = document.getElementById('cfg-logo-opts');
  var dropzone  = document.getElementById('cfg-dropzone');
  var fileInput = document.getElementById('cfg-logo-input');

  function loadLogoFile(file) {
    if (!file || !file.type.startsWith('image/')) return;
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        state.logo = img;
        logoThumb.src = e.target.result;
        logoName.textContent = file.name;
        dzEmpty.style.display  = 'none';
        dzFilled.style.display = 'flex';
        logoOpts.style.display = 'flex';
        draw();
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  document.getElementById('cfg-browse').addEventListener('click', function () {
    fileInput.click();
  });

  fileInput.addEventListener('change', function () {
    if (this.files[0]) loadLogoFile(this.files[0]);
  });

  dropzone.addEventListener('dragover', function (e) {
    e.preventDefault();
    this.classList.add('drag-over');
  });
  dropzone.addEventListener('dragleave', function () {
    this.classList.remove('drag-over');
  });
  dropzone.addEventListener('drop', function (e) {
    e.preventDefault();
    this.classList.remove('drag-over');
    if (e.dataTransfer.files[0]) loadLogoFile(e.dataTransfer.files[0]);
  });

  document.getElementById('cfg-remove-logo').addEventListener('click', function () {
    state.logo    = null;
    fileInput.value = '';
    dzEmpty.style.display  = 'flex';
    dzFilled.style.display = 'none';
    logoOpts.style.display = 'none';
    draw();
  });

  /* ── Logo size ── */
  document.getElementById('cfg-logo-size').addEventListener('input', function () {
    state.logoSizePct = parseInt(this.value, 10);
    document.getElementById('cfg-size-val').textContent = this.value + '%';
    draw();
  });

  /* ── Logo alignment ── */
  document.querySelectorAll('.cfg-align-grid button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.cfg-align-grid button').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      state.logoPos = this.dataset.pos;
      draw();
    });
  });

  /* ── Text fields ── */
  ['produit', 'prix', 'lot', 'date'].forEach(function (f) {
    var el = document.getElementById('cfg-' + f);
    if (el) {
      el.addEventListener('input', function () {
        state.texts[f] = this.value;
        draw();
      });
    }
  });

  /* ── Download ── */
  document.getElementById('cfg-dl').addEventListener('click', function () {
    var a = document.createElement('a');
    a.download = 'etiquette-balance-' + state.format.w + 'x' + state.format.h + '.png';
    a.href = canvas.toDataURL('image/png');
    a.click();
  });

  /* ── Modal devis ── */
  var modal = document.getElementById('cfg-modal');

  function buildRecap() {
    var t = state.texts;
    var html = '<strong>Format :</strong> ' + state.format.label;
    if (t.produit) html += '<br><strong>Produit :</strong> ' + t.produit;
    if (t.prix)    html += '<br><strong>Prix/kg :</strong> ' + t.prix;
    if (t.lot)     html += '<br><strong>Lot :</strong> ' + t.lot;
    if (t.date)    html += '<br><strong>Date :</strong> ' + t.date;
    if (state.logo) html += '<br><em>Logo : inclus</em>';
    return html;
  }

  function openModal() {
    document.getElementById('cfg-modal-recap').innerHTML = buildRecap();

    var t = state.texts;
    var cfg = 'Format: ' + state.format.label;
    if (t.produit) cfg += ' | Produit: ' + t.produit;
    if (t.prix)    cfg += ' | Prix/kg: ' + t.prix;
    if (t.lot)     cfg += ' | Lot: ' + t.lot;
    if (t.date)    cfg += ' | Date: ' + t.date;
    if (state.logo) cfg += ' | Logo: oui';
    document.getElementById('cfg-modal-config').value = cfg;

    var logoNote = document.getElementById('cfg-modal-logo-note');
    if (logoNote) logoNote.style.display = state.logo ? '' : 'none';

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.getElementById('cfg-open-devis').addEventListener('click', openModal);
  document.getElementById('cfg-modal-close').addEventListener('click', closeModal);
  document.getElementById('cfg-modal-overlay').addEventListener('click', closeModal);

  var close2 = document.getElementById('cfg-modal-close2');
  if (close2) close2.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ── Initial draw ── */
  draw();

})();
